import { faCircleInfo, faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { BASE_URL } from "../../../api/EndPoints";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const EditCart = ({ ribData, setEditItem, editItem, items, handleEditSave, cancelRemove, setError, sampleMoq, wholesaleMoq, error, uom }) => {
  const mainItemUom = uom[editItem.variantSku] || "";
  const metrtokg = editItem.ribItem ? editItem?.ribItem?.meterPerKg : 0;
  const ribRatio = editItem.ribItem ? editItem?.ribItem?.ratio : 0;
  const check = mainItemUom === "metre";
  const checkkg = mainItemUom === "kgs";
  const qty = editItem?.quantity || 0;
  const mainvalue = mainItemUom === "metre"
    ? (qty / metrtokg * ribRatio) / 100
    : (qty * ribRatio) / 100;
  const finalribvalue = Math.ceil(mainvalue);
  const location = useLocation();
  const oim = location?.state?.pimDate;
  const ribItemUom = editItem.ribItem ? uom[editItem.ribItem.variantSku] || "unknown" : null;

  useEffect(() => {

    setEditItem(prev => ({
      ...prev,
      ribItem: prev.ribItem
        ? { ...prev.ribItem, quantity: finalribvalue }
        : prev.ribItem
    }));
  }, [editItem?.quantity, ribRatio]);

  return (<div className="app-modal">
    <div className="modal-fixed-container">
      <div className="modal-backdrop opened"></div>
      <div className="modal-edit-cart-product scrollable-body modal-base-style">
        <div className="modal-header">
          <div>
            <div className="title">Edit Amount</div>
          </div>
          <FontAwesomeIcon className="far flex-wrap m-l-a close-icon" icon={faTimes} onClick={cancelRemove} />
        </div>
        <div className="body">
          <div className="m-b-8">Color</div>
          <div className="adaptive-layout boundary-width-768 items-center" style={{ gap: '24px', marginBottom: '12px' }}>
            <div className="wrapper-product-info flex-fill">
              <div className="image-container flex-wrap">
                <div className="product-image-thumbnail center overlay">
                  <img className="app-img cover" src={`${BASE_URL}${editItem.image?.replace("/api", "")}?time=${Date?.now()}`} alt="SwatchOn - No. 1 Wholesale fabric platform for Fashion Brands" loading="lazy" />
                </div>
              </div>
              <div className="lcn-container">
                <div className="flex-row items-center">
                  <div className="ql-code">{editItem.articleCode}</div>
                </div>
                <div className="pd-code">
                  <h3>    {editItem?.articleName}</h3>
                  <span className="clickable-area">{editItem.variantSku}</span>
                </div>
                <div className="badges">
                  <div className="badge-sample-dark">{editItem.cartType === 'SAMPLE' ? 'SAMPLE' : ''}</div>
                </div>
                <div className="adaptive-label-color-number">
                  <span>#{editItem.value}</span>
                </div>
              </div>
            </div>
            <div className="flex items-end flex-wrap">
              <div className="input-wrapper" style={{ display: 'flex', alignItems: 'center', flexDirection: 'row' }}>
                <input
                  placeholder={
                    editItem.cartType === 'SAMPLE'
                      ? `${editItem.sampleMoq || sampleMoq}~${editItem.wholesaleMoq || wholesaleMoq}`
                      : `${editItem.wholesaleMoq || wholesaleMoq}+`
                  }
                  min={
                    editItem.cartType === 'SAMPLE'
                      ? (editItem.sampleMoq || sampleMoq)
                      : (editItem.wholesaleMoq || wholesaleMoq)
                  }
                  type="number"
                  value={editItem.cartType === 'WHOLESALE' ? Math.round(editItem?.quantity / (editItem?.kgPerRoll)) : editItem?.quantity}
                  onChange={(s) => {
                    const value = s.target.value;
                    const parsedValue = (value) * (editItem?.kgPerRoll || 1);
                    setError('');
                    setEditItem(prev => ({
                      ...prev,
                      quantity: parsedValue,
                    }));
                  }}
                  max={editItem.cartType === 'SAMPLE' && (editItem.wholesaleMoq || wholesaleMoq)}
                />

                <span className="flex-wrap m-l-8 c-gray-400">{editItem.cartType === 'WHOLESALE' ? "Rolls" : uom[editItem.variantSku]}</span>
              </div>
              {editItem.cartType === 'WHOLESALE' && <div className="validation-error" style={{ color: 'grey', fontSize: '12px', display: 'flex', justifyContent: 'flex-start' }}>
                Total {mainItemUom} : {editItem?.quantity}

              </div>}
              {error && <div className="validation-error" style={{ color: 'red', fontSize: '12px' }}>
                {error}
              </div>}
              {/* <div className="f-12 c-gray-500 m-t-4">minimum {editItem.cartType === 'SAMPLE' ? (editItem.sampleMoq || sampleMoq) : (editItem.wholesaleMoq || wholesaleMoq)} kg</div> */}

            </div>
          </div>
          {/* ................................................................for rib ................................................ */}
          {editItem?.ribItem && (


            <div className="adaptive-layout boundary-width-768 items-center" style={{ gap: '2px' }}>


              <div className="wrapper-product-info">


                <div className="image-container flex-wrap">


                  <div className="product-image-thumbnail center overlay">
                    <img className="app-img cover" src={`${BASE_URL}${editItem?.ribItem?.image?.replace("/api", "")}?time=${Date?.now()}`} alt="SwatchOn - No. 1 Wholesale fabric platform for Fashion Brands" loading="lazy" />
                  </div>
                </div>
                <div className="lcn-container">
                  <div className="flex-row items-center">
                    <div className="ql-code">{editItem?.ribItem?.articleCode}</div>
                  </div>
                  <div className="pd-code">
                    <h3>{editItem?.ribItem?.articleName}</h3>
                    <span className="clickable-area">{editItem?.ribItem?.variantSku}</span>
                  </div>
                  <div className="badges">
                    <div className="badge-sample-dark">{editItem?.ribItem?.cartType === 'SAMPLE' ? 'SAMPLE' : ''}</div>
                  </div>
                  <div className="adaptive-label-color-number">
                    <span>#{editItem?.ribItem?.value}</span>
                  </div>
                </div>
              </div>
              <div className="flex items-end flex-wrap">
                <div className="input-wrapper" style={{ display: 'flex', alignItems: 'center', flexDirection: 'row' }}>
                  <input
                    type="number"
                    pattern="\d*"
                    disabled={true}
                    value={finalribvalue}
                    onChange={(e) => {
                      setError('');
                      setEditItem(prev => ({
                        ...prev,
                        ribItem: {
                          ...prev.ribItem,
                          quantity: finalribvalue
                        }
                      }));
                    }}
                  />

                  <span className="flex-wrap m-l-8 c-gray-400">{editItem?.ribItem?.cartType === 'WHOLESALE' ? "Kgs" : uom[editItem?.ribItem?.variantSku]}</span>
                </div>
                {/* {editItem?.ribItem?.cartType === 'WHOLESALE' && <div className="validation-error" style={{ color: 'grey', fontSize: '12px', display: 'flex', justifyContent: 'flex-start' }}>
                  Total Rib Qty : {editItem?.ribItem?.quantity} Qty
                </div>} */}
                {error && <div className="validation-error" style={{ color: 'red', fontSize: '12px' }}>
                  {error}
                </div>}
                {/* <div className="f-12 c-gray-500 m-t-4">minimum {editItem.cartType === 'SAMPLE' ? (editItem.sampleMoq || sampleMoq) : (editItem.wholesaleMoq || wholesaleMoq)} kg</div> */}

              </div>
            </div>
          )}
          {/* ...................................................................................... */}
          <div className="stock-notice-box m-t-8">
            <div className="notice">
              <FontAwesomeIcon className='i fa' icon={faCircleInfo} />
              <div>To minimize the likelihood of order cancellation, we recommend orders are above the advised MOQ.</div>
            </div>
          </div>
          <button className="btns btn-primary btn-block p-16 m-t-24" onClick={handleEditSave}>Save</button>
        </div>
      </div>
    </div>
  </div>)
}
export default EditCart;